import HttpService from '../HttpService'

const _http = new HttpService()
export default {
    find: (search) => {
        return _http.get(`/api/institutions-issues/auto-complete?search=${search}`)
    }
}